import styled from "styled-components";
import colors from "../../../../../config/colors";
import { Scrollable } from "../../../../../common/styles";

export const ProgramsListSectionContainer = styled.div`
  border-bottom: 1px solid ${colors.secondary};
`;

export const ButtonContainer = styled.div`
  background-color: #f5f7fb;
  border: none;
  cursor: pointer;
`;

export const FolderContainer = styled.div`
  background-color: #fafafc;
  margin: 12px;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  gap: 6px;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
`;

export const FolderName = styled.div`
  line-height: 40px;
  height: 40px;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: bold;
  width: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FolderNameInputField = styled.input`
  line-height: 40px;
  height: 40px;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: bold;
  width: 350px;
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TableActions = styled.div`
  padding: 0px 5px;
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.isActive ? "center" : "flex-start")};
  position: relative;
`;

export const DropdownItems = styled.div`
  position: absolute;
  min-width: max-content;
  top: 15px;
  left: -80px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
  z-index: 2;
`;

export const DropdownButton = styled.button`
  width: 100%;
  min-width: fit-content;
  padding: 10px;
  border: none;
  border-bottom: 1px solid #ddd;
  background-color: white;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  svg {
    margin-right: 8px;
  }
`;
export const FolderPrograms = styled.div``;
